module.exports = __webpack_public_path__ + "static/media/FortuneTellingBall.5313cbec.svg";